import { Component, OnInit } from '@angular/core';
import { BannerComponent } from '../../shared/components/banner/banner.component';
import { TextblockComponent } from '../../shared/components/textblock/textblock.component';
import { ITextblock } from '../../core/interfaces/textblock.interface';
import { StatusService } from 'src/app/core/services/status.service';

@Component({
  selector: 'aig-notfound-page',
  templateUrl: './notfound-page.component.html',
  styleUrls: ['./notfound-page.component.scss'],
  imports: [BannerComponent, TextblockComponent],
})
export class NotfoundPageComponent implements OnInit {
  bannerInfo = {
    image: './assets/images/bg-ciberseguridad.jpg',
    alt: 'Imagen de fondo página not found',
  };

  public status: string = 'ko';

  public statusData: ITextblock[] = [];

  constructor(private statusService: StatusService) {}

  ngOnInit() {
    this.statusService.status$.subscribe((status) => {
      this.status = status;
    });
  }
  public getCurrentStatus(): ITextblock {
    let current: ITextblock = {
      status: 'ko',
      icon: 'icon-warning-advertencia',
      title: 'Lo sentimos, no se encontró la página',
      subtitle: 'Acepta nuestras disculpas por las molestias.',
    };

    this.statusData.some((i) => {
      if (i.status === this.status) {
        current = i;
        return true;
      }
      return false;
    });

    return current;
  }
}
